import { lazy } from "react";
import { RouteConfig } from "../../../../types/RouteConfig";

export const calorClaimsViewRoute: RouteConfig<'with-page'> = {
    name: 'My Claims',
    path: '/rewards/calor/claims',
    page: lazy(() => import('.')),
    flags: ['member-route'],
    permissions: ['rewards'],
    context: 'member',
}